export const environment = {
    name: "production",
    production: true
};
